import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppService } from '../app.service';
@Component({
  selector: 'app-accountcreation',
  templateUrl: './accountcreation.component.html',
  styleUrls: ['./accountcreation.component.scss']
})
export class AccountcreationComponent implements OnInit {
 // itAccountForm!: FormGroup;
  constructor(public appservice:AppService,private router: Router,private toastr: ToastrService) { }
 onSubmit() {
  this.add.createdby=this.appservice.username;
  console.log("the datas are ", this.add)
   this.appservice.postTable("api/Transaction/Insert_ITAccountcreation",this.add).subscribe((res:any)=>{
     if(res!=""){ 
      this.toastr.success("Approved successfully!");
      this.appservice.getItemployeeid(); 
        this.add.firstName='';
  this.add.lastName='';
  this.add.fullName='';
  this.add.designation='';
  this.add.grade='';
  this.add.Plant='';
  this.add.Department='';
      this.appservice.goback();
     
     }})
    

   
       //this.router.navigate(['/hrclosure']);
 }
 public rec:any=[];
getemployeedetails(data:any){
  this.appservice.getTable("Api/Transaction/Getempdetails12?empid="+data).subscribe((res:any)=>{
if(res!=""){
 this.rec=JSON.parse(res); 
  if (this.rec && this.rec.length > 0) {
    let emp = this.rec[0]; 
this.add.name=emp.OD_First_name+' '+emp.OD_Last_Name;
this.add.designation=emp.OD_Designation;
this.add.grade=emp.OD_Grad;
this.add.plant=emp.OD_Plant;
this.add.department=emp.OD_Department;
this.add.dateofjoin=this.appservice.formatCustomDate(emp.OD_Dateofjoin);
this.add.requestername=emp.OD_OnboardingCreatedby;
this.add.checkername=emp.OD_CheckerCreatedby;
this.add.finalapprovername=emp.OD_FinalApprovedby;
this.add.ADusername=emp.OD_ITAD_AccountName??'';
this.add.contactMail=emp.OD_CMailid??'';
console.log("the finalapprovedby",emp.OD_FinalApprovedby);
  }
}else{
  this.add.firstName='';
  this.add.lastName='';
  this.add.fullName='';
  this.add.designation='';
  this.add.grade='';
  this.add.Plant='';
  this.add.Department='';
  this.add.OD_Dateofjoin='';
}
  });
}
async loadData(){
  await this.appservice.getItemployeeid(); {
    console.log("the employe ids",this.appservice.Itcreationemployeeid);
  this.add.OD_EmployeeID=Number(this.appservice.ItFacilityEditdata);
  this.getemployeedetails(this.appservice.ItFacilityEditdata);}
}
 public add:any={};
  ngOnInit(): void {
  //       this.itAccountForm = this.fb.group({
  //     //accountCreation: [false],  // default off
  //     adUsername: ['', [Validators.required, Validators.minLength(3)]],
  //     contactMail: ['', [Validators.required, Validators.email]]
  //   });
  // }
this.loadData();
 // console.log("the employe ids",this.appservice.Itcreationemployeeid);
  }
}

